import React from 'react';
import avatar from '../../images/avatarDefault.svg';
import './agentcard.scss';
const AgentCard = ({ image = avatar, name = 'Bryan Krailler', onClick, children, Style }) => {
  return (
    <div className="aocontent" onClick={onClick} style={Style}>
      <img
        src={image}
        alt="user"
        className="avatar-user"
        style={{
          width: !!children ? '80px' : '',
          height: !!children ? '80px' : '',
        }}
      />
      {!!children ? children : <span>{name}</span>}
    </div>
  );
};

export default AgentCard;
